export enum MyPortfolioViewEnum {
  All = 'all',
  Workstream = 'workstream',
  Project = 'project',
}

export enum MyPortfolioColumnsEnum {
  TaskName = 'taskName',
  TaskStatus = 'taskStatus',
  DueDate = 'dueDate',
  DaysRemaining = 'daysRemaining',
  AssigneeName = 'assigneeName',
  ProjectName = 'projectName',
  WorkstreamName = 'workstreamName',
  LoggedTime = 'loggedTime',
  ApproverName = 'approverName',
  ReviewerName = 'reviewerName',
  StartDate = 'startDate',
  ApplicableFrom = 'applicableFrom',
  ApplicableTo = 'applicableTo',
  DateCompleted = 'dateCompleted',
  Recurrence = 'recurrence',
  IsMilestone = 'isMilestone',
}
